// extracted by mini-css-extract-plugin
export default {"voteContainer":"Vote_voteContainer__Lt6Tb","incrementButton":"Vote_incrementButton__fNPZO","decrementButton":"Vote_decrementButton__KBXPU","votesNumber":"Vote_votesNumber__ISzM6"};